import { api } from './client';

export const contasPagarApi = {
  listar: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return api.get(`/contas-pagar${qs ? `?${qs}` : ''}`);
  },
  resumo: (data) => api.get(`/contas-pagar/resumo?data=${data}`),
  resumoPeriodo: (dataDe, dataAte) => api.get(`/contas-pagar/resumo-periodo?data_de=${dataDe}&data_ate=${dataAte}`),
  criar: (dados) => api.post('/contas-pagar', dados),
  atualizar: (id, dados) => api.put(`/contas-pagar/${id}`, dados),
  pagar: (id, dataPagamento) => api.post(`/contas-pagar/${id}/pagar`, { data_pagamento: dataPagamento }),
  cancelar: (id) => api.post(`/contas-pagar/${id}/cancelar`)
};

export const ressarcimentoStApi = {
  listar: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return api.get(`/ressarcimento-st${qs ? `?${qs}` : ''}`);
  }
};

export const contasReceberApi = {
  listar: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return api.get(`/contas-receber${qs ? `?${qs}` : ''}`);
  },
  resumo: (data) => api.get(`/contas-receber/resumo?data=${data}`),
  resumoPeriodo: (dataDe, dataAte) => api.get(`/contas-receber/resumo-periodo?data_de=${dataDe}&data_ate=${dataAte}`),
  criar: (dados) => api.post('/contas-receber', dados),
  atualizar: (id, dados) => api.put(`/contas-receber/${id}`, dados),
  receber: (id, dataRecebimento) => api.post(`/contas-receber/${id}/receber`, { data_recebimento: dataRecebimento }),
  cancelar: (id) => api.post(`/contas-receber/${id}/cancelar`)
};
